// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Utils = require("../../../utils/Utils.bs.js");
let RelayEnv = require("../../../RelayEnv.bs.js");
let DebounceP = require("../../../reason/common/DebounceP.bs.js");
let ReasonPromise = require("../../../reason/ReasonPromise.bs.js");
let AutocompleteV5 = require("../../autocomplete/AutocompleteV5.bs.js");
let Utils__Promise = require("../../../utils/Utils__Promise.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let SelectInputTextSize = require("../../common/Form/SelectInputTextSize.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let CityZipAutocompleteV5Query_graphql = require("../../../__generated__/CityZipAutocompleteV5Query_graphql.bs.js");
let CityZipAutocompleteV5_result_graphql = require("../../../__generated__/CityZipAutocompleteV5_result_graphql.bs.js");

let getConnectionNodes = CityZipAutocompleteV5_result_graphql.Utils.getConnectionNodes;

let convertFragment = CityZipAutocompleteV5_result_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, CityZipAutocompleteV5_result_graphql.node, convertFragment, fRef);
}

function readInline(fRef) {
  return RescriptRelay_Fragment.readInlineData(CityZipAutocompleteV5_result_graphql.node, convertFragment, fRef);
}

let Fragment = {
  getConnectionNodes: getConnectionNodes,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  readInline: readInline
};

let convertVariables = CityZipAutocompleteV5Query_graphql.Internal.convertVariables;

let convertResponse = CityZipAutocompleteV5Query_graphql.Internal.convertResponse;

let convertWrapRawResponse = CityZipAutocompleteV5Query_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, CityZipAutocompleteV5Query_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, CityZipAutocompleteV5Query_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(CityZipAutocompleteV5Query_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch_(CityZipAutocompleteV5Query_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(CityZipAutocompleteV5Query_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(CityZipAutocompleteV5Query_graphql.node, convertVariables);

let Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function getOptionValue(param) {
  return param.id;
}

function getOptionLabel(param) {
  return param.label;
}

let Area = {
  getOptionValue: getOptionValue,
  getOptionLabel: getOptionLabel
};

function queryFn(searchTerm) {
  return ReasonPromise.map(Utils__Promise.fromJsPromise(fetchPromised(RelayEnv.environment, {
    searchTerm: searchTerm
  }, undefined, undefined)), v => {
    if (v.TAG !== "Ok") {
      return {
        TAG: "Error",
        _0: {
          NAME: "REJECTED",
          VAL: v._0
        }
      };
    }
    let r = v._0.cityZipAutocompleteV5;
    if (r === undefined) {
      return {
        TAG: "Error",
        _0: "EMPTY_RESULT"
      };
    }
    let response = RescriptRelay_Fragment.readInlineData(CityZipAutocompleteV5_result_graphql.node, convertFragment, r.fragmentRefs);
    let areas = getConnectionNodes(response.areas);
    return {
      TAG: "Ok",
      _0: areas.map(param => ({
        id: param.id,
        label: param.label
      }))
    };
  });
}

function CityZipAutocompleteV5(props) {
  let status = props.status;
  let onChange = props.onChange;
  let value = props.value;
  let queryFn$1 = DebounceP.make(300, input => Utils__Promise.toJsPromise(queryFn(input)));
  let defaultOpts;
  if (value !== undefined) {
    let value$1 = Primitive_option.valFromOption(value);
    defaultOpts = value$1 !== undefined ? [value$1] : [];
  } else {
    defaultOpts = [];
  }
  let value$2;
  if (value !== undefined) {
    let value$3 = Primitive_option.valFromOption(value);
    value$2 = value$3 !== undefined ? value$3 : undefined;
  } else {
    value$2 = undefined;
  }
  return JsxRuntime.jsx("div", {
    children: JsxRuntime.jsx(AutocompleteV5.AsyncSelect.Single.make, {
      getOptionLabel: getOptionLabel,
      getOptionValue: getOptionValue,
      isClearable: true,
      loadOptions: v => {
        let v$1 = Utils.$$String.trimInput(v);
        if (v$1.length < 2) {
          return Promise.resolve(defaultOpts);
        } else {
          return queryFn$1(Utils.$$String.trimInput(v$1));
        }
      },
      onBlur: props.onBlur,
      onFocus: props.onFocus,
      onChange: value => {
        if (onChange !== undefined) {
          return onChange(value);
        }
      },
      noOptionsMessage: v => v.length < 2 ? "Type at least two characters" : "No locations match \"" + v + "\"",
      placeholder: "Please enter a city or a zip code",
      status: status !== undefined ? (
          status === "ok" ? "Success" : "Failure"
        ) : "Neutral",
      value: value$2
    }),
    className: SelectInputTextSize.className
  });
}

let make = CityZipAutocompleteV5;

exports.Fragment = Fragment;
exports.Query = Query;
exports.Area = Area;
exports.queryFn = queryFn;
exports.make = make;
/* use Not a pure module */
